import React from 'react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, boxImage } from '../data/salesCopy';
export function Hero() {
  return <section className="bg-brand-ivory px-4 pb-8 pt-7 sm:pb-10 sm:pt-10" data-id="element-90" data-mp="eibqho5m10ai">
      <div className="mx-auto max-w-3xl text-center" data-id="element-91" data-mp="9lv1krql6hwd">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-92" data-mp="9ih0dmtnseqi">
          Yin Yoga Pro™
        </p>
        <h1 className="mt-2 font-serif text-[27px] font-bold uppercase leading-[1.08] text-brand-brown sm:text-5xl" data-id="element-93" data-mp="12a0kra1zryu3">
          Le système visuel complet pour les professeurs de Yin Yoga
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-[13px] font-medium leading-snug text-brand-brown/85 sm:text-[15px]" data-id="element-94" data-mp="saruar6c52ch">
          Arrêtez de perdre du temps à chercher des postures, construire des
          séquences et organiser chaque nouveau cours à partir de zéro. Accédez à
          des postures visuelles, des séquences structurées, des modèles de
          création, des adaptations, des séances thématiques et des outils de
          planification — organisés dans un seul système professionnel.
        </p>

        <a href={OFFER_ANCHOR} className="mt-4 block" data-id="element-95" data-mp="3o6kfvj9sie5n">
          <img src={boxImage} alt="Coffret YIN YOGA PRO™ — système complet 6 modules" className="mx-auto w-full max-w-[300px] sm:max-w-[380px]" data-id="element-96" data-mp="3o59ajf0p4ycf" />
        </a>

        <div className="mt-3 flex justify-center" data-id="element-97" data-mp="30i19xae7qdgq">
          <CTAButton size="lg" data-id="element-98" data-mp="30h9djxcskbpe">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-brand-taupe sm:text-xs" data-id="element-99" data-mp="359j9pv4i2804">
          <span data-id="element-100" data-mp="2qi0lxb5ef967">🛡️ Garantie satisfait ou remboursé de 7 jours</span>
          <span className="rounded-full bg-brand-sand px-2.5 py-1 text-brand-brown" data-id="element-101" data-mp="2vjg4mwk3t3lf">
            🧘 Système complet 6-en-1
          </span>
        </div>
      </div>
    </section>;
}